import { SessaoState } from '../redux/reduxTypes';
import { InformacoesCliente } from '../types/EdClienteTypes';
import api from './apiEdCliente';
import { ParamsCadastrarNovoCliente } from '../types/EdClienteTypes';
import ClienteUsuario from '../Entity/ClienteUsuario';
import { Empresa } from '../Entity/Empresa';

const PREFIX = 'api';
const ROUTE = 'edcliente/auth';

class ApiAutenticacao {
  async enviarCodigoVerificacao(
    opcao: number,
    dadosCliente: InformacoesCliente,
    telefoneSelecionado: string
  ) {
    const res = await api.post<SessaoState>(`/${PREFIX}/${ROUTE}/enviarCodigoVerificacao`, {
      opcao,
      dadosCliente,
      telefoneSelecionado
    });
    const data = res.data;
    return data;
  }

  async confirmarCodigoVerificacao(codigoVerificacao: string, dadosCliente: InformacoesCliente) {
    const res = await api.post<SessaoState>(`/${PREFIX}/${ROUTE}/confirmarCodigoVerificacao`, {
      codigoVerificacao,
      dadosCliente
    });
    const data = res.data;
    return data;
  }

  async login(login: string, senha: string) {
    const res = await api.post<SessaoState>(
      `/${PREFIX}/${ROUTE}/`,
      {
        login,
        senha
      },
      { timeout: 20000 }
    );
    const data = res.data;
    return data;
  }

  async cadastrarUsuarioCliente(documento: string, senha: string) {
    const res = await api.post<SessaoState>(
      `/${PREFIX}/${ROUTE}/cadastrarUsuarioCliente`,
      {
        documento,
        senha
      },
      { timeout: 20000 }
    );
    const data = res.data;
    return data;
  }

  async atualizarSenha(senha: string) {
    const res = await api.post<SessaoState>(`/${PREFIX}/${ROUTE}/atualizarSenha`, { senha });
    const data = res.data;
    return data;
  }

  async getStatusWhatsApp() {
    const res = await api.get<string>(`/${PREFIX}/${ROUTE}/getStatusWhatsApp`);
    const data = res.data;
    return data;
  }

  async getStatusEmail() {
    const res = await api.get<boolean>(`/${PREFIX}/${ROUTE}/getStatusEmail`);
    const data = res.data;
    return data;
  }

  async getPermiteCadastroCliente() {
    const res = await api.get<boolean>(`/${PREFIX}/${ROUTE}/getPermiteCadastroCliente`);
    const data = res.data;
    return data;
  }

  async cadastrarNovoCliente(params: ParamsCadastrarNovoCliente) {
    const res = await api.post<ClienteUsuario>(`/${PREFIX}/${ROUTE}/cadastrarNovoCliente`, {
      params
    });
    const data = res.data;
    return data;
  }

  async getEmpresaEdCliente() {
    const res = await api.get<Empresa>(`/${PREFIX}/${ROUTE}/getEmpresaEdCliente`, {});
    const data = res.data;
    return data;
  }

  async buscaDadosCliente(documento: string) {
    const res = await api.post<InformacoesCliente>(
      `/${PREFIX}/${ROUTE}/buscaDadosCliente`,
      {
        documento
      },
      { timeout: 20000 }
    );
    const data = res.data;
    return data;
  }

  async enviarCodigoRecuperacaoSenha(
    opcao: number,
    dadosCliente: InformacoesCliente,
    telefoneSelecionado: string
  ) {
    const res = await api.post<SessaoState>(`/${PREFIX}/${ROUTE}/enviarCodigoRecuperacaoSenha`, {
      opcao,
      dadosCliente,
      telefoneSelecionado
    });
    const data = res.data;
    return data;
  }

  async confirmarCodigoRecuperacaoSenha(
    codigoVerificacao: string,
    dadosCliente: InformacoesCliente
  ) {
    const res = await api.post<SessaoState>(`/${PREFIX}/${ROUTE}/confirmarCodigoRecuperacaoSenha`, {
      codigoVerificacao,
      dadosCliente
    });
    const data = res.data;
    return data;
  }
}

const apiAutenticacao = new ApiAutenticacao();
export default apiAutenticacao;
